export const services = [
  {
    title: "Free shipping",
    tagline: "From all orders above $5",
    image: "images/service.png",
  },

  {
    title: "Daily surprise offers",
    tagline: "Save upto 25% off",
    image: "images/service-02.png",
  },

  {
    title: "Support 24/7",
    tagline: "Shop with an expert",
    image: "images/service-03.png",
  },

  {
    title: "Affordable prices",
    tagline: "Get factory default price",
    image: "images/service-04.png",
  },

  {
    title: "Secure payments",
    tagline: "100% protected payment",
    image: "images/service-05.png",
  },
];
